const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const loadFromStorage = <T>(key: string): T | null => {
  if (!isBrowser) return null;

  try {
    const value = window.localStorage.getItem(key);
    if (!value) return null;
    return JSON.parse(value) as T;
  } catch (error) {
    console.warn('Failed to read from storage', key, error);
    return null;
  }
};

export const saveToStorage = <T>(key: string, value: T) => {
  if (!isBrowser) return;

  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn('Failed to save to storage', key, error);
  }
};

export const removeFromStorage = (key: string) => {
  if (!isBrowser) return;

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn('Failed to remove from storage', key, error);
  }
};
